import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LogsTrackingResponse, LogsTrackingRequest } from '../../interfaces/logs_tracking.interface.';
import { Global } from '../global';

@Injectable({
  providedIn: 'root'
})
export class LogTackingService {
  private API_URL: string;

  constructor(private httpClient: HttpClient) {
    this.API_URL = Global.url + '/logs'
  }

  generateTrackingLog(request: LogsTrackingRequest): Observable<LogsTrackingResponse> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post<LogsTrackingResponse>(`${this.API_URL}/create_log`, request, { headers: headers, withCredentials: true });
  }
}
